import { createFileRoute } from '@tanstack/react-router';
import { NewsReview } from '~portal/components/admin/automations/news/NewsReview';

/** @desc Ario → News review (`add-news-collectors` D6): approve or reject collected drafts. */
export const Route = createFileRoute('/_protected/admin/ario/news')({
  component: NewsReview,
});
